import { OrderType } from '../../providers/request/order-type.enum';
import { SearchRequest } from '../../providers/request/search-request.model';
import { JgRfiFormValueType } from './jg-rfi-form-value-type.enum';
export class JgPhysicalInspUnitFxItemSearchRequest extends SearchRequest {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  dwTypeName?: string;
  dwTypeNameSort?: number;
  dwCode?: string;
  dwCodeSort?: number;
  dwName?: string;
  jgFbName?: string;
  jgFbNameSort?: number;
  jgFxName?: string;
  jgFxProjectTypeCode?: string;
  jgFxProjectTypeName?: string;
  jgInspItemCode?: string;
  jgInspItemName?: string;
  jgInspItemCodeSort?: number;
  lastJgRfiFormNo?: number;
  completedCount?: number;
  inspectedCount?: number;
  designedCount?: number;
  sgFormCode?: string;
  sgFormId?: number;
  jgRfiFormValueType?: JgRfiFormValueType;
  jgRfiFormCodeFactor?: string;
  jgRfiFormId?: number;
  jgRfiFormCode?: string;
  jgRfiFormName?: string;
  inRecycleBin?: boolean;
  comment?: string;
  dwTypeNameSortOrder?: OrderType;
  dwCodeSortOrder?: OrderType;
  dwNameOrder?: OrderType;
  jgFbNameSortOrder?: OrderType;
  jgFbNameOrder?: OrderType;
  jgFxNameOrder?: OrderType;
  jgInspItemCodeSortOrder?: OrderType;
}
